import { createContext, useContext } from 'react'

export type CardPreviewLayout = 'card' | 'slideIn'

const CardPreviewLayoutContext = createContext<CardPreviewLayout>('card')

export const CardPreviewLayoutProvider = CardPreviewLayoutContext.Provider

export const useCardPreviewLayout = () => useContext(CardPreviewLayoutContext)
